export default __webpack_public_path__ + "static/dron-6784ae22f4c92098f8d2ff5899d4b292.jpg";